import { LoadingButton } from '@mui/lab';
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
  TextField,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Transition } from '../../components/Transition';

interface IProps {
  toggle: boolean;
  onClose: () => void;
  values: any;
  handleSubmit: () => void;
  setFieldValue: (key: string, value: any) => void;
  handleChange: (e: React.ChangeEvent<any>) => void;
  errors: any;
  touched: any;
  isSubmitting: boolean;
  resetForm: () => void;
}

const FormModal: React.FC<IProps> = ({
  toggle,
  onClose,
  errors,
  touched,
  values,
  isSubmitting,
  setFieldValue,
  handleChange,
  handleSubmit,
  resetForm,
}) => {
  return (
    <Dialog
      fullWidth
      open={toggle}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => {
        resetForm();
        onClose();
      }}
    >
      <DialogTitle>
        {values.id ? 'Edit Rejection Reason' : 'New Rejection Reason'}
      </DialogTitle>
      <form onSubmit={handleSubmit} autoComplete='off'>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id='en'
                name='en'
                label='English'
                multiline
                minRows={2}
                value={values.en}
                onChange={handleChange}
                error={Boolean(touched.en && errors.en)}
                helperText={touched.en && errors.en}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id='ar'
                name='ar'
                label='Arabic'
                multiline
                minRows={2}
                value={values.ar}
                onChange={handleChange}
                error={Boolean(touched.ar && errors.ar)}
                helperText={touched.ar && errors.ar}
                inputProps={{ dir: 'rtl' }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type='number'
                id='sortOrder'
                name='sortOrder'
                label='Sort Order'
                value={values.sortOrder}
                onChange={handleChange}
                error={Boolean(touched.sortOrder && errors.sortOrder)}
                helperText={touched.sortOrder && errors.sortOrder}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                display: 'flex',
                alignItems: 'center',
                minHeight: { sm: 56 },
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Boolean(values.activeState)}
                    onChange={(e) =>
                      setFieldValue('activeState', e.target.checked)
                    }
                  />
                }
                label='Active'
                sx={{ m: 0 }}
              />
              {touched.activeState && errors.activeState && (
                <FormHelperText error>{errors.activeState}</FormHelperText>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              resetForm();
              onClose();
            }}
          >
            Cancel
          </Button>
          <LoadingButton type='submit' variant='contained' loading={isSubmitting}>
            Save
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default FormModal;
